'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024 from "./presto.types$.js";
import * as $j_presto$002etypes$0024$002dAllow$002dPayload from "./presto.types$-Allow-Payload.js";
import * as $j_presto$002etypes$0024$002dIp$002dPayload from "./presto.types$-Ip-Payload.js";
import * as $j_presto$002etypes$0024$002dTime$002dPayload from "./presto.types$-Time-Payload.js";
import * as $j_presto$002etypes$0024$002dWeek$002dDay$002dPayload from "./presto.types$-Week-Day-Payload.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule(id, account, created, deleted, name, description, payload) {
  this.l5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.LG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.LH = null;
  this.LI = null;
  this.n7 = null;
  this.ub = null;
  this.qt = null;
  this.l5 = id;
  this.LG = account;
  this.LH = created;
  this.LI = deleted;
  this.n7 = name;
  this.ub = description;
  this.qt = payload;
}
export { $c_Lpresto_types$Rule as $c_Lpresto_types$Rule };
$p = $c_Lpresto_types$Rule.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule;
/** @constructor */
function $h_Lpresto_types$Rule() {
}
export { $h_Lpresto_types$Rule as $h_Lpresto_types$Rule };
$h_Lpresto_types$Rule.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Rule"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.l5;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_3 = acc;
  var t$1 = this.LG;
  acc = $x_4.o($x_3, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t$1.e, t$1.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.LH));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.LI));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.n7));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.ub));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.qt));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 7);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Rule)) {
    var this$1 = this.l5;
    var b = x$0.l5;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      var this$2 = this.LG;
      var b$1 = x$0.LG;
      var $x_3 = ((this$2.e === b$1.e) && (this$2.f === b$1.f));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x = this.LH;
      var x$2 = x$0.LH;
      var $x_2 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.LI;
      var x$4 = x$0.LI;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ((($x_1 && (this.n7 === x$0.n7)) && (this.ub === x$0.ub))) {
      var x$5 = this.qt;
      var x$6 = x$0.qt;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 7;
});
$p.s = (function() {
  return "Rule";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.l5;
      break;
    }
    case 1: {
      return this.LG;
      break;
    }
    case 2: {
      return this.LH;
      break;
    }
    case 3: {
      return this.LI;
      break;
    }
    case 4: {
      return this.n7;
      break;
    }
    case 5: {
      return this.ub;
      break;
    }
    case 6: {
      return this.qt;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.cq5 = (function() {
  var x185 = this.qt;
  if ((x185 instanceof $j_presto$002etypes$0024$002dAllow$002dPayload.$c_Lpresto_types$AllowPayload)) {
    return "Acesso Liberado";
  }
  if ((x185 instanceof $j_presto$002etypes$0024$002dIp$002dPayload.$c_Lpresto_types$IpPayload)) {
    return x185.Ex;
  }
  if ((x185 instanceof $j_presto$002etypes$0024$002dTime$002dPayload.$c_Lpresto_types$TimePayload)) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T(x185.EJ.a2(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((r) => ((("entre " + r.uk.a4f()) + " e ") + r.uj.a4f())))), "", ", ", "");
  }
  if ((x185 instanceof $j_presto$002etypes$0024$002dWeek$002dDay$002dPayload.$c_Lpresto_types$WeekDayPayload)) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(x185.EN, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$4) => _$4.av)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$Int$()).a2(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$5) => $j_presto$002etypes$0024.$m_Lpresto_types$().crJ(_$5)))), "", ", ", "");
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x185);
});
$p.k4 = (function() {
  return this.l5;
});
function $isArrayOf_Lpresto_types$Rule(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kb)));
}
export { $isArrayOf_Lpresto_types$Rule as $isArrayOf_Lpresto_types$Rule };
var $d_Lpresto_types$Rule = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule, "presto.types$Rule", ({
  kb: 1,
  aH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Rule as $d_Lpresto_types$Rule };
//# sourceMappingURL=presto.types$-Rule.js.map
